import { render } from "./enroll_student.vue?vue&type=template&id=2d36253a&scoped=true"
import script from "./enroll_student.vue?vue&type=script&lang=js"
export * from "./enroll_student.vue?vue&type=script&lang=js"

import "./enroll_student.vue?vue&type=style&index=0&id=2d36253a&scoped=true&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d36253a"]])

export default __exports__